import React from "react";
import "./BookParticipantsType.css";

export default class BookParticipantsType extends React.Component<
  { type: number; onChange: any },
  {}
> {
  constructor(props: any) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <>
        <div className="course-participants-type-container">
          <div
            className={`course-participants-type-background course-participants-type-background-${this.props.type}`}
          ></div>
          <div className="course-type-inner-container">
            <div
              onClick={() => {
                this.props.onChange(1);
              }}
              className={
                this.props.type === 1
                  ? "course-participants-type-selected course-participants-type"
                  : "course-participants-type"
              }
            >
              Nicht Registriert
            </div>
            <div
              onClick={() => {
                this.props.onChange(2);
              }}
              className={
                this.props.type === 2
                  ? "course-participants-type course-participants-type-selected"
                  : "course-participants-type"
              }
            >
              Registriert
            </div>
          </div>
        </div>
      </>
    );
  }
}
